/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingPaymentMethod } from './BillingPaymentMethod';
import {
    BillingPaymentMethodFromJSON,
    BillingPaymentMethodFromJSONTyped,
    BillingPaymentMethodToJSON,
    BillingPaymentMethodToJSONTyped,
} from './BillingPaymentMethod';

/**
 * 
 * @export
 * @interface ListPaymentMethodsResponse
 */
export interface ListPaymentMethodsResponse {
    /**
     * 
     * @type {Array<BillingPaymentMethod>}
     * @memberof ListPaymentMethodsResponse
     */
    data: Array<BillingPaymentMethod>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListPaymentMethodsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListPaymentMethodsResponse interface.
 */
export function instanceOfListPaymentMethodsResponse(value: object): value is ListPaymentMethodsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListPaymentMethodsResponseFromJSON(json: any): ListPaymentMethodsResponse {
    return ListPaymentMethodsResponseFromJSONTyped(json, false);
}

export function ListPaymentMethodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPaymentMethodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingPaymentMethodFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListPaymentMethodsResponseToJSON(json: any): ListPaymentMethodsResponse {
      return ListPaymentMethodsResponseToJSONTyped(json, false);
  }

  export function ListPaymentMethodsResponseToJSONTyped(value?: ListPaymentMethodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingPaymentMethodToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

